'use client'

import {Pagination as SharedPagination, type PaginationProps as SharedPaginationProps} from '@fitro/customer-ui/Pagination'
import {useTranslation} from '../../../hooks/useTranslation'

export type PaginationProps = Omit<SharedPaginationProps, 'locale'>

export function Pagination(props: PaginationProps) {
    const {locale} = useTranslation()

    return <SharedPagination {...props} locale={locale}/>
}
